import React from 'react';
import { Calendar } from 'primereact/components/calendar/Calendar';
import './DateInput.styles';

const DateInput = props => {
  return <Calendar showTime={true} hourFormat="24" {...props} />;
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/inputs/date/DateInput.js